/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as AgentsIdRouteImport } from './routes/agents/$id'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as ApprovalsIndexRouteImport } from './routes/approvals/index'
import { Route as ApprovalsIdRouteImport } from './routes/approvals/$id'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as DailyIndexRouteImport } from './routes/daily/index'
import { Route as KeywordsIndexRouteImport } from './routes/keywords/index'
import { Route as MarketingIndexRouteImport } from './routes/marketing/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIdRoute = AgentsIdRouteImport.update({
  id: '/agents/$id',
  path: '/agents/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsIndexRoute = ApprovalsIndexRouteImport.update({
  id: '/approvals/',
  path: '/approvals/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsIdRoute = ApprovalsIdRouteImport.update({
  id: '/approvals/$id',
  path: '/approvals/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const DailyIndexRoute = DailyIndexRouteImport.update({
  id: '/daily/',
  path: '/daily/',
  getParentRoute: () => rootRouteImport,
} as any)
const KeywordsIndexRoute = KeywordsIndexRouteImport.update({
  id: '/keywords/',
  path: '/keywords/',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/marketing/',
  path: '/marketing/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/agents/$id': typeof AgentsIdRoute
  '/approvals/$id': typeof ApprovalsIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/approvals/': typeof ApprovalsIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/daily/': typeof DailyIndexRoute
  '/keywords/': typeof KeywordsIndexRoute
  '/marketing/': typeof MarketingIndexRoute
  '/reports/': typeof ReportsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/agents/$id': typeof AgentsIdRoute
  '/approvals/$id': typeof ApprovalsIdRoute
  '/agents': typeof AgentsIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/approvals': typeof ApprovalsIndexRoute
  '/blog': typeof BlogIndexRoute
  '/daily': typeof DailyIndexRoute
  '/keywords': typeof KeywordsIndexRoute
  '/marketing': typeof MarketingIndexRoute
  '/reports': typeof ReportsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/agents/$id': typeof AgentsIdRoute
  '/approvals/$id': typeof ApprovalsIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/approvals/': typeof ApprovalsIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/daily/': typeof DailyIndexRoute
  '/keywords/': typeof KeywordsIndexRoute
  '/marketing/': typeof MarketingIndexRoute
  '/reports/': typeof ReportsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/agents/$id'
    | '/approvals/$id'
    | '/agents/'
    | '/analytics/'
    | '/approvals/'
    | '/blog/'
    | '/daily/'
    | '/keywords/'
    | '/marketing/'
    | '/reports/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/agents/$id'
    | '/approvals/$id'
    | '/agents'
    | '/analytics'
    | '/approvals'
    | '/blog'
    | '/daily'
    | '/keywords'
    | '/marketing'
    | '/reports'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/agents/$id'
    | '/approvals/$id'
    | '/agents/'
    | '/analytics/'
    | '/approvals/'
    | '/blog/'
    | '/daily/'
    | '/keywords/'
    | '/marketing/'
    | '/reports/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  AgentsIdRoute: typeof AgentsIdRoute
  ApprovalsIdRoute: typeof ApprovalsIdRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  ApprovalsIndexRoute: typeof ApprovalsIndexRoute
  BlogIndexRoute: typeof BlogIndexRoute
  DailyIndexRoute: typeof DailyIndexRoute
  KeywordsIndexRoute: typeof KeywordsIndexRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$id': {
      id: '/agents/$id'
      path: '/agents/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof AgentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals/': {
      id: '/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof ApprovalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals/$id': {
      id: '/approvals/$id'
      path: '/approvals/$id'
      fullPath: '/approvals/$id'
      preLoaderRoute: typeof ApprovalsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/daily/': {
      id: '/daily/'
      path: '/daily'
      fullPath: '/daily/'
      preLoaderRoute: typeof DailyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/keywords/': {
      id: '/keywords/'
      path: '/keywords'
      fullPath: '/keywords/'
      preLoaderRoute: typeof KeywordsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/': {
      id: '/marketing/'
      path: '/marketing'
      fullPath: '/marketing/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  AgentsIdRoute: AgentsIdRoute,
  ApprovalsIdRoute: ApprovalsIdRoute,
  AgentsIndexRoute: AgentsIndexRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  ApprovalsIndexRoute: ApprovalsIndexRoute,
  BlogIndexRoute: BlogIndexRoute,
  DailyIndexRoute: DailyIndexRoute,
  KeywordsIndexRoute: KeywordsIndexRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
